import React, { useEffect, useState, useLayoutEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setCoupon } from "../../features/CouponSlice";

import icoCoupon from "../../assets/img/ci/coupon/ico-coupon.svg";

import Helper, { convertDateFormat } from "services/helper";

import useTranslations from "../../i18n/useTranslations";

const CardCoupon = (props) => {
  const { t } = useTranslations(); // แปลภาษา

  const dispatch = useDispatch(); // ไว้อัพเดต state กลาง
  const stateCoupon = useSelector((state) => state.coupon);

  const setDataCoupon = (newData) => {
    const tmpObj = { id: newData.id, data: newData };
    dispatch(setCoupon(tmpObj)); // setStateRedux ส่งค่าเก็บเข้า state กลาง
  };

  /* Handle goto coupon detail page */
  const navigate = useNavigate();

  const handleGotoCouponDetail = (e) => {
    e.preventDefault();
    // console.log("handleGotoCouponDetail >>", props.dataCoupon);

    setDataCoupon(props.dataCoupon);

    navigate("/coupon/detail");
  };
  /* End Handle goto coupon detail page */

  useEffect(() => {
    // console.log(stateCoupon);
  }, [stateCoupon]);

  const [height, setHeight] = useState(0);
  const eleRef = useRef(null);

  useEffect(() => {
    // console.log(props.index, height, props.curHeight);
    props.setNewHeight(props.index, height);
  }, [height]);

  useLayoutEffect(() => {
    const handleResize = () => {
      setHeight(eleRef.current.offsetHeight);
    };
    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <article
      ref={eleRef}
      data-to-date={convertDateFormat(props.toDate)}
      data-discount={props.discount}
    >
      <div className="bPic">
        <img
          src={props.thumbnail !== null ? props.thumbnail : icoCoupon}
          alt=""
        />
      </div>
      <div className="divider"></div>
      <div className="bDetails">
        <div className="bValue">
          <div className="bDate">
            {t.couponPage.cardValidTill}{" "}
            {convertDateFormat(props.toDate, "d/m/y")}
          </div>
          <span>{t.lang === "en" ? props.nameEn : props.nameTh}</span>
          {t.couponPage.cardForSpend.str1}{" "}
          {Helper.FN.toNumberWithCommas(props.minTotal)}{" "}
          {t.couponPage.cardForSpend.str2}
        </div>
        <div className="bPoint">
          <span>
            {Helper.FN.toNumberWithCommas(props.point)} {t.couponPage.cardPoint}
          </span>
          <div className="bBtn">
            <a href="#" onClick={handleGotoCouponDetail}>
              {t.couponPage.cardRedeem}
            </a>
          </div>
        </div>
      </div>
    </article>
  );
};

export default CardCoupon;
